const cssStyles = () => `
.Gender__customGenderTooltip:after, .customGenderTooltip:before {
  bottom: 100%;
  left: 92.5%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.Gender__customGenderTooltip:after {
  border-color: rgba(255, 255, 255, 0);
  border-bottom-color: #ffffff;
  border-width: 10px;
  margin-left: -10px;
}
.Gender__customGenderTooltip:before {
  border-color: rgba(145, 145, 145, 0);
  border-bottom-color: #919191;
  border-width: 11px;
  margin-left: -11px;
}
.Gender__customGenderTooltipMobile:after, .customGenderTooltip:before {
  bottom: 100%;
  left: 92.5%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.Gender__customGenderTooltipMobile:after {
  border-color: rgba(255, 255, 255, 0);
  border-width: 10px;
  margin-left: -10px;
}
.Gender__customGenderTooltipMobile:before {
  border-color: rgba(145, 145, 145, 0);
  border-bottom-color: #919191;
  border-width: 11px;
  margin-left: -11px;
}
.Gender__customGenderTooltipText:after, .customGenderTooltip:before {
  bottom: 100%;
  left: 92.5%;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}
.Gender__customGenderTooltipText:after {
  border-color: rgba(255, 255, 255, 0);
  border-width: 10px;
  margin-left: 5px;
  margin-top: 10px;
}
.Gender__customGenderTooltipText:before {
  border-color: rgba(145, 145, 145, 0);
  border-bottom-color: #919191;
  border-width: 11px;
  margin-left: 5px;
  margin-top: 10px;
}
`;

export default cssStyles;
